import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';

@Component({
    templateUrl: './ds-dropdown-list.component.html',
    styleUrls: ['./ds-dropdown-list.component.scss'],
    standalone: false
})
export class DsDropdownListComponent implements OnInit, AfterViewInit {

  @Input() host: HTMLElement;
  @Input() template: TemplateRef<any>;
  @Input() hide: boolean;
  @Input() position: 'top' | 'bottom';
  @Input() align: 'left' | 'right';
  @Input() darkMode: boolean = false;
  @Input() maxHeight: string;
  @Input() width: number;

  @ViewChild('dropdownList') dropdownList: ElementRef;

  public dropdownStyle: any = {};

  constructor() {
  }

  ngOnInit(): void {
    const hostBoundingBox: ClientRect = this.host.getBoundingClientRect();
    this.dropdownStyle.width = this.width ? this.width + 'px' : hostBoundingBox.width + 'px';
    // this.renderList();
  }

  ngAfterViewInit() {
    this.renderList();
  }

  private renderList(): void {
    const hostBoundingBox: ClientRect = this.host.getBoundingClientRect();
    const dropdownList: ClientRect = this.dropdownList.nativeElement.getBoundingClientRect();
    let top: number | 'unset' = 'unset';
    let bottom: number | 'unset' = 'unset';
    let left: number | 'unset' = 0;
    let padding: string;

    switch (this.position) {
      case 'top':
        if (hostBoundingBox.top - dropdownList.height + 5 > 0) {
          bottom = window.innerHeight - hostBoundingBox.top;
          padding = '0 0 5px';
        } else {
          top = hostBoundingBox.bottom;
          padding = '5px 0 0';
        }
        break;

      case 'bottom':
        if (hostBoundingBox.bottom + dropdownList.height + 5 <= window.innerHeight) {
          top = hostBoundingBox.bottom;
          padding = '5px 0 0 0';
        } else {
          bottom = window.innerHeight - hostBoundingBox.top;
          padding = '0 0 5px 0';
        }
        break;
    }

    switch (this.align) {
      case "left":
        left = hostBoundingBox.left;
        break;
      case "right":
        left = this.width ? hostBoundingBox.right - this.width : hostBoundingBox.right - hostBoundingBox.width;
        break;
    }

    this.dropdownStyle.top = top === 'unset' ? 'unset' : top + 'px';
    this.dropdownStyle.bottom = bottom === 'unset' ? 'unset' : bottom + 'px';
    this.dropdownStyle.left = left ? left + 'px' : 'unset';
    this.dropdownStyle.padding = padding;
    this.dropdownStyle.opacity = 1;
  }

}
